import React from "react"

import * as S from "./banner-image.styles"

const BannerImage = ({ image }) => {
  if (!image) return null
  return (
    <S.Section>
      <S.Image img={image} alt="banner" />
    </S.Section>
  )
}

export default BannerImage
